if (!customElements.get('pop-product-options')) {
  class PopProductOptions extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;
      this.addEventListener('input', () => this.update());
      this.addEventListener('change', () => this.update());
      this.update();
    }
    update() {
      this.querySelectorAll('[data-pop-trim]').forEach(input => {
        input.setCustomValidity(input.required && !input.value.trim() ? input.dataset.emptyError : '');
      });
      this.querySelectorAll('[data-pop-writing]').forEach(input => {
        const field = input.closest('[data-pop-field]') || input.parentElement;
        const counter = field.querySelector('[data-pop-count]');
        if (counter) counter.textContent = input.value.length;
      });
      this.querySelectorAll('[data-pop-file]').forEach(input => {
        const file = input.files[0];
        const maxMB = Number(input.dataset.popMaxMb || 5);
        const wrongType = input.accept && file && !input.accept.split(',').includes(file.type);
        input.setCustomValidity(file && (file.size > maxMB * 1024 * 1024 || wrongType) ? `Please choose a file up to ${maxMB} MB${input.accept ? ' in JPG, PNG or WebP format' : ''}.` : '');
      });
    }
  }
  customElements.define('pop-product-options', PopProductOptions);
}
